import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../utils/ToastFile";
import { addContractor, updateContractor } from "../../api/ContractorApi";
import { getAllTenants } from "../../api/TenantApi";

const AddUpdateContractor = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const [tenants, setTenants] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    getTenants();
  }, []);

  const getTenants = () => {
    getAllTenants()
      .then((res) => {
        if (res.status === 200) {
          setTenants(res?.data?.data?.tenants);
          if (state?.contractor) {
            setIsActionEdit(true);
            reset(state?.contractor);
          } else {
            setIsActionEdit(false);
          }
        } else {
          ToastFile("Failed to fetch tenants", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tenants:", err);
        ToastFile("Error fetching tenants", "error");
      });
  };

  const onSubmit = (data) => {
    let payload = {
      ...data,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (isActionEdit) {
      updateContractor(state?.contractor?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Contractor updated successfully", "updated");
            setTimeout(() => {
              navigate("/contractors");
            }, 2000);
          } else {
            ToastFile("Failed to update contractor", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating contractor:", err);
          ToastFile("Error updating contractor", "error");
        });
      reset();
      setIsActionEdit(false);
    } else {
      addContractor(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Contractor added successfully", "added");
            setTimeout(() => {
              navigate("/contractors");
            }, 2000);
          } else {
            ToastFile("Failed to add contractor", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding contractor:", err);
          ToastFile("Error adding contractor", "error");
        });
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">
            {" "}
            {isActionEdit ? "Edit Contractor" : "Add Contractor"}
          </h3>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              {...register("name", { required: true })}
              isInvalid={errors.name}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              {...register("email", { required: true })}
              isInvalid={errors.email}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              {...register("password", { required: true })}
              isInvalid={errors.password}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register("address", { required: false })}
              isInvalid={errors.address}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Contact No</Form.Label>
            <Form.Control
              type="text"
              {...register("contact_no", { required: false })}
              isInvalid={errors.contact_no}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Tenant</Form.Label>
            <Form.Select
              {...register("tenant_id", { required: true })}
              isInvalid={errors.tenant_id}
            >
              <option value="">Select Tenant</option>
              {tenants.map((tenant) => (
                <option key={tenant._id} value={tenant._id}>
                  {tenant.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              {...register("status", { required: true })}
              isInvalid={errors.status}
            >
              <option value="">Select status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
          <Button variant="primary" type="submit">
            {isActionEdit ? "Update" : "Add"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/contractors")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default AddUpdateContractor;
